<div class="form-group product__option" *ngIf="initialized">
    <div class="flex flex-col sm:flex-row mobile:items-center sm:gap-6">
        <div class="col-auto">
            <mat-calendar #calendar class="w-64" [selected]="selectedDate" [minDate]="today" [maxDate]="maxDate" [dateFilter]="dateFilter" (selectedChange)="onSelect($event)">
            </mat-calendar>
        </div>
        <div class="col-auto">
            <div class="times-select range" *ngIf="timeType == 'time_range'">
                <app-timeRange-view [product]="product" [time]="form.get('timeRange')"></app-timeRange-view>
            </div>
        </div>

        <!-- List picked Dates -->
        <ng-container *ngIf="dates.value?.length">
            <div class="pb-4">
                <h4 class="my-2">{{"chosen_dates"|translate}}:</h4>
                <div class="flex flex-wrap gap-2">
                    <div *ngFor="let date of dates.value; let i = index" class="selected-date-item">
                        <div class="title">{{ date | date}}</div>
                        <button class="delete-button" type="button" mat-icon-button (click)="deleteDate(i)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</div>